/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (paymentTypeId, connectionPaymentTypes) => ({
    type: actions.EDIT_CONNECTION_PAYMENT_TYPES,
    payload: {
        id: paymentTypeId,
        connectionPaymentTypes,
    },
});